import { loadStripe } from '@stripe/stripe-js';

// Publishable key for Stripe.js (safe to expose client-side). Supplied via a
// CRA build-time env var so it differs per environment — set
// REACT_APP_STRIPE_PUBLISHABLE_KEY in .env.local / the deployment config.
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Load Stripe once and share the promise. Null when no key is configured so the
// checkout can degrade gracefully instead of throwing during local dev.
export const stripePromise = STRIPE_PUBLISHABLE_KEY
  ? loadStripe(STRIPE_PUBLISHABLE_KEY)
  : null;
